/**
 * Define all global constants for the package
 * */
export const WIDGET_USER_KPI_TYPE = 'learning-user-kpi';
